const UTM_PARAMS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_id', 'utm_term', 'utm_content'] as const;
const SESSION_STORAGE_KEY = 'gesteco_tracking_values';

/**
 * Capture les paramètres UTM de l'URL courante et les sauvegarde dans le sessionStorage.
 * Si de nouveaux paramètres UTM sont présents dans l'URL, ils remplacent ceux en session.
 * Doit être appelé au chargement de chaque page.
 */
export function captureTrackingValues(): void {
  const fromUrl = extractUtmFromUrl();
  if (fromUrl) {
    sessionStorage.setItem(SESSION_STORAGE_KEY, fromUrl);
  }
}

/**
 * Retourne les TrackingValues sauvegardés (URL courante ou sessionStorage).
 */
export function getTrackingValues(): string | undefined {
  return extractUtmFromUrl() ?? sessionStorage.getItem(SESSION_STORAGE_KEY) ?? undefined;
}

function extractUtmFromUrl(): string | undefined {
  const params = new URLSearchParams(window.location.search);
  const parts: string[] = [];

  for (const key of UTM_PARAMS) {
    const value = params.get(key);
    if (value) {
      parts.push(`${key}=${value}`);
    }
  }

  return parts.length > 0 ? parts.join('|') : undefined;
}

/**
 * Cherche un champ input avec name="trackingValues" dans le DOM et y assigne la valeur courante.
 * Ne fait rien si le champ n'existe pas ou s'il n'y a pas de valeur de tracking.
 */
export function populateTrackingInput(): void {
  const trackingValues = getTrackingValues();
  if (!trackingValues) return;

  const element = document.querySelector('.trackingValues') as HTMLElement | null;
  if (!element) return;

  if (element instanceof HTMLInputElement) {
    element.value = trackingValues;
  }
}
